import styled from "@emotion/styled";

export const Button = styled.button`
  padding: 0.75em 0.875em;
  font-size: 12px;
  line-height: 1.25;
  font-weight: 700;
  color: #000000;
  background-color: ${(props) =>
    props.theme === "alt" ? "transparent" : "#76b900"};
  border: ${(props) => (props.theme === "alt" ? "2px solid #76b900" : "none")};
  margin-right: 10px;
  min-width: ${(props) => (props.theme === "link" ? "0" : "120px")};
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  &:hover {
    background-color: ${(props) =>
      props.theme === "alt" ? "transparent" : "#91c733"};
    border-color: ${(props) => (props.theme === "alt" ? "#000000" : "none")};
  }
  transition: all 0.2s ease-out;
`;

export const ButtonsContainer = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: row-reverse;

  @media (max-width: 400px) {
    flex-direction: column;
    row-gap: 10px;
    button {
      width: 100%;
    }
  }
`;
